// init scripts
import ready from './init/ready';
import focusable from './init/focusable';
import scroll from './init/scroll';
import detect from './init/detect';
import viewport from './init/viewport';
import backtotop from './init/backtotop';
import forminputs from './init/form-inputs';
import lightbox from './init/lightbox';
import fone from './init/fone';
import goalTracking from './init/goal-tracking';
import dataEventLayer from './init/data-event-layer';
import salesforceLiveAgent from './init/salesforce-live-agent';

// setup scripts
import jquery from './setup/jquery';
import pointerEvent from './setup/pointer-event';
/**
 * Global initialization.
 *
 * This has to run after as early as possible, *after* DOM ready.
 */
export default (($, /* eslint-disable */ window, undefined /* eslint-enable */) => {
  /**
   * Global initialization
   */
  const init = () => {
    ready();
    focusable();
    viewport();
    scroll();
    detect();
    backtotop();
    forminputs();
    lightbox();
    fone();
    goalTracking();
    dataEventLayer();
    window._aggrekoLiveChat = salesforceLiveAgent();
  };

  /**
   * Global setup
   * 
   * This contains only critical setup and that to runs right after main JS is loaded
   */
  const setup = () => {
    pointerEvent();
    jquery();
  };

  return {
    init,
    setup
  };
})(jQuery, window);
